<div role="button" (click)="showContractDetail()">
    <a class="btn btn-link p-0 m-0">
        <em class="fas fa-link text-primary mr-2 fa-xs"></em>
        <span>{{ contract?.title }}</span>
    </a>
</div>
